// extracted by mini-css-extract-plugin
export default {"pageAction":"PageAction_pageAction__2hk2o"};